
const PlansPage = () => {
  return (
    <span>plansPage</span>
  );
  
};

export default PlansPage;
